import React, { useEffect, useState } from "react";
import {
  CancelButton,
  SaveAndUpdate,
} from "../../utils/commonComponent/Custom/Button";
import { useNavigate, useParams } from "react-router-dom";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { TextFields } from "../../utils/commonComponent/Custom/custominput";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import {
  editAccessOptions,
  moduleHierarchy,
  moduleList,
} from "../../utils/commonComponent/userConstant";
import { BASE_URL, DISABLED_MODULE } from "../../global";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { toast } from "react-toastify";

// Filter out disabled modules
const EnabledModules = moduleList.filter(
  (module) => !DISABLED_MODULE.includes(module.label)
);

const EditRBCAMaster = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [inputStates, setInputStates] = useState({
    roleName: "",
    access: [],
    selectedModules: [],
  });
  const [modules, setModules] = useState(EnabledModules);

  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({ ...prev, [key]: value }));
  };

  const initModules = () => {
    let filteredModules = EnabledModules?.filter((module) => {
      if (
        !Object.values(moduleHierarchy).some(
          (range) => module.id >= range.min && module.id <= range.max
        )
      ) {
        return true;
      }
      return inputStates.selectedModules.some((selectedModule) => {
        const range = moduleHierarchy[selectedModule.id];
        return range && module.id >= range.min && module.id <= range.max;
      });
    });
    setModules(filteredModules);
  };

  // Fetch RBAC details for edit
  const fetchRBACDetails = async () => {
    try {
      const [RBACdata] = await fetchQuery(`select * from rbac where id = ${params.id}`);
      if (RBACdata) {
        // Populate roleName
        updateInputObject("roleName", RBACdata.roleName || "");

        // Populate selectedModules by matching IDs
        const selectedModules = EnabledModules.filter((module) =>
          RBACdata.moduleId?.split(",").includes(module.id.toString())
        );
        updateInputObject("selectedModules", selectedModules);

        // Populate access by matching IDs
        const selectedAccess = editAccessOptions.filter((opt) =>
          RBACdata.access?.split(",").includes(opt.id.toString())
        );
        updateInputObject("access", selectedAccess);
      }
    } catch (error) {
      console.error("Error fetching RBAC details:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchRBACDetails();
  }, [params]);

  useEffect(() => {
    initModules();
  }, [inputStates.selectedModules]);

  const onSubmit = async () => {
    try {
      // Prepare payload
      const payload = {
        roleName: inputStates.roleName,
        moduleId: inputStates.selectedModules.map((m) => m.id).join(","),
        access: inputStates.access.map((a) => a.id).join(","),
      };

      let url = BASE_URL + "rbac";

      if (params.id == 0) {
        // Add new record
        await axiosWithToken.post(url, payload);
      } else {
        // Update existing record
        await axiosWithToken.patch(url + `/${params.id}`, payload);
      }
      toast.success(
        params.id == 0
          ? "Role Created Successfully!"
          : "Role Updated Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/rbacList"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (err) {
      console.error(err);
      alert("Error saving RBAC");
    }
  };

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="w-full">
          <TextFields
            label="Role Name *"
            value={inputStates.roleName}
            onChange={(e) => updateInputObject("roleName", e.target.value)}
          />
        </div>

        <div className="w-full">
          <Autocomplete
            multiple
            sx={{ width: "100%" }}
            size="small"
            options={modules}
            value={inputStates.selectedModules}
            disableCloseOnSelect
            getOptionLabel={(option) => option?.label || ""}
            renderOption={(props, option, { selected }) => (
              <li
                {...props}
                style={{ paddingLeft: option.id > 50 ? "1rem" : "0" }}
              >
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select modules (optional)"
                placeholder="Select multiple modules"
              />
            )}
            limitTags={3}
            onChange={(e, val) => updateInputObject("selectedModules", val)}
          />
        </div>

        <div className="w-full">
          <Autocomplete
            multiple
            sx={{ width: "100%" }}
            size="small"
            options={editAccessOptions}
            value={inputStates.access}
            disableCloseOnSelect
            getOptionLabel={(option) => option?.label || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Edit Access"
                placeholder="Edit Access"
              />
            )}
            onChange={(e, val) => updateInputObject("access", val)}
          />
        </div>
      </div>

      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        <SaveAndUpdate
          id="btn-add-outline"
          label={params.id == 0 ? "Save" : "Update"}
          onClick={onSubmit}
        />
      </div>
    </div>
  );
};

export default EditRBCAMaster;
